import { api } from "../../axiosApi";

export const OutletFoodList = async ({ search = "" } = {}) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get(`/api/v1/outlet/order/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        search,
        pageSize: 100,
        currentPage: 1,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};



export const OutletFoodPlaceOrder = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.post(`/api/v1/outlet/food/place-order`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const OutletFoodModifyPlaceOrder = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.put(`/api/v1/outlet/food/complete-order`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const OutletFoodPlaceOrderByID = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.post(`/api/v1/outlet/food/complete-orderbyid`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const OutletFoodOrderList = async ({ currentPage = 1, pageSize = 1000 }) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get(`/api/v1/outlet/food/list`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { currentPage, pageSize }, // send as query params
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
export const GetCompletedOrders = async () => {
  try {
    const token = localStorage.getItem("access_token");
      const rawUser = localStorage.getItem("userDetails");
    const user = JSON.parse(rawUser || "{}");
     const franchiseId =
      user?.userDetails?.franchise_details?.id || user?.franchise_details?.id;

    const response = await api.get(`/api/v1/outlet/food/completed-orders`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { franchise_id: franchiseId }, // send as query params
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const FoodOrderPayment = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.post(`/api/v1/outlet/food/payment`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};


export const FoodOrderEdit = async (data) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.put(`/api/v1/outlet/food/order-update`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};



export const FoodOrderDetailsById = async ({ orderId }) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get(`/api/v1/outlet/food/order-details`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { orderId },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const FoodOrderCancel = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.post(`/api/v1/outlet/food/cancel`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};


export const FoodOrderPrintReceipt = async ({ orderId }) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get(`/api/v1/outlet/food/pdf-generate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { orderId },
      responseType: "blob", // important! return file as blob
    });
    return response.data; // this will be the PDF blob
  } catch (error) {
    console.error(error);
    throw new Error(error?.response?.data?.message || "Failed to fetch receipt");
  }
};

export const FoodOrderReceiptJson = async ({ orderId }) => {
  const token = localStorage.getItem("access_token");
  const response = await api.get(`/api/v1/outlet/food/pdf-generate`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { orderId } // no need for format anymore
  });
  return response.data;
};


export const OrderPrintReceipt = async ({ orderId }) => {
  try {
    const token = localStorage.getItem("access_token");
    const response = await api.get(`/api/v1/outlet/food/approve/${orderId}`, {
      responseType: "blob", // ensures we get PDF as blob
    });
    return response.data; // PDF blob
  } catch (error) {
    console.error("OrderPrintReceipt error:", error);
    throw new Error(error?.response?.data?.message || "Failed to fetch receipt");
  }
};

export const OrderviewPrintReceipt = async ({ orderId }) => {
  try {
    const response = await api.get(
      `/api/v1/outlet/food/approve/${orderId}`,
      { responseType: "blob" }
    );
    return response.data; // PDF blob
  } catch (error) {
    console.error("OrderPrintReceipt error:", error);

    // ✅ RETURN ERROR AS BLOB (instead of throwing)
    if (error?.response?.data instanceof Blob) {
      return error.response.data; // JSON error blob
    }

    // fallback error blob
    return new Blob(
      [JSON.stringify({ message: "Failed to generate invoice" })],
      { type: "application/json" }
    );
  }
};




// export const addOpeningBalance = async (payload) => {
//   try {
//     const token = localStorage.getItem("access_token");
//     const response = await api.post(`/api/v1/outlet/food/add`, payload, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     return error?.response?.data;
//   }
// };
export const addOpeningBalance = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");

    // ✅ Safely parse franchise ID from localStorage
    const rawUser = localStorage.getItem("userDetails");
    const user = JSON.parse(rawUser || "{}");
    const franchiseId =
      user?.userDetails?.franchise_details?.id || user?.franchise_details?.id;

    if (!franchiseId) {
      console.error("⚠️ Franchise ID missing in userDetails:", user);
      throw new Error("Franchise ID missing in localStorage");
    }

    // ✅ Merge payload with franchise ID
    const finalPayload = {
      ...payload,
      franchises_id: franchiseId,
    };

    console.log("📦 Final Payload:", finalPayload);

    // ✅ Use correct backend route
    const response = await api.post(
      `/api/v1/outlet/food/add`,
      finalPayload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("❌ addOpeningBalance error:", error);
    return error?.response?.data || { success: false, message: error.message };
  }
};



// export const getEODBalance = async (payload) => {
//   try {
//     const token = localStorage.getItem("access_token");
//     const response = await api.get(`/api/v1/outlet/food/eod`, payload, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     return error?.response?.data;
//   }
// };

export const getEODBalance = async () => {
  try {
    const token = localStorage.getItem("access_token");

    // ✅ Safely parse franchise ID from localStorage
    const rawUser = localStorage.getItem("userDetails");
    const user = JSON.parse(rawUser || "{}");
    const franchiseId =
      user?.userDetails?.franchise_details?.id || user?.franchise_details?.id;

    if (!franchiseId) {
      console.error("⚠️ Franchise ID missing in userDetails:", user);
      throw new Error("Franchise ID missing in localStorage");
    }

    // ✅ Send as query param
    const response = await api.get(`/api/v1/outlet/food/eod`, {
      params: { franchises_id: franchiseId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ getEODBalance error:", error);
    return error?.response?.data || { success: false, message: error.message };
  }
};



// export const addExpense = async (payload) => {
//   try {
//     const token = localStorage.getItem("access_token");
//     const response = await api.post(`/api/v1/outlet/food/expense`, payload, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     return error?.response?.data;
//   }
// };

export const addExpense = async (payload) => {
  try {
    const token = localStorage.getItem("access_token");

    // ✅ Safely get franchise ID from localStorage
    const rawUser = localStorage.getItem("userDetails");
    const user = JSON.parse(rawUser || "{}");
    const franchiseId =
      user?.userDetails?.franchise_details?.id || user?.franchise_details?.id;

    if (!franchiseId) {
      console.error("⚠️ Franchise ID missing in userDetails:", user);
      throw new Error("Franchise ID missing in localStorage");
    }

    // ✅ Merge franchise ID into payload
    const finalPayload = {
      ...payload,
      franchises_id: franchiseId,
    };

    console.log("📤 addExpense payload:", finalPayload);

    const response = await api.post(`/api/v1/outlet/food/expense`, finalPayload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("❌ addExpense error:", error);
    return error?.response?.data || { success: false, message: error.message };
  }
};



